import * as Yup from 'yup';
import { formatEuro } from '@doveit/hammer';
import { Offer } from '../../../../providers/api/dtos';

export const validationSchema = (offerValue: Offer['value']) => (
  Yup.object({
    isValueChanged: Yup
      .boolean()
      .required('Il campo è obbligatorio'),
    value: Yup
      .string()
      .when('isValueChanged', {
        is: true,
        then: (schema) => schema
          .required('Il campo è obbligatorio')
          .test(
            'higher-than-offer-value',
            `La controproposta deve avere un importo superiore a ${formatEuro(offerValue)}`,
            (value) => !Number.isNaN(value) && parseInt(value, 10) > offerValue,
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
    contractAmendments: Yup
      .array()
      .of(
        Yup.object({
          value: Yup.string().trim().required('La modifica contrattuale non può essere vuota'),
        }),
      )
      .when('isValueChanged', {
        is: false,
        then: (schema) => schema.min(
          1,
          'È necessario indicare almeno una modifica contrattuale',
        ),
        otherwise: (schema) => schema.notRequired(),
      }),
  }));
